<input id="aside-drawer" type="checkbox" class="drawer-toggle" />
<!--<div class="drawer-content">-->
<div
  class="bg-base-100/90 text-base-content sticky top-0 z-1000 flex h-16 w-full [transform:translate3d(0,0,0)] justify-center backdrop-blur transition-shadow duration-100 print:hidden"
>
  <nav class="navbar w-full pt-0 py-0">
    <div class="flex flex-1 items-center md:gap-1 lg:gap-2">
      <span
        class="tooltip tooltip-bottom before:text-xs before:content-[attr(data-tip)]"
        data-tip="Menu"
      >
        <label
          aria-label="Open menu"
          for="aside-drawer"
          class="btn btn-square btn-ghost drawer-button lg:hidden"
        >
          <svg-icon
            src="./assets/icons/menu.svg"
            [svgClass]="'inline-block h-5 w-5 stroke-current md:h-6 md:w-6 text-base-content'"
          ></svg-icon>
        </label>
      </span>
      <div class="flex items-center gap-2">
        <!--    Logo    -->
        <a
          href="/"
          aria-current="page"
          aria-label="daisyUI"
          class="me-2 flex w-35 shrink-0 items-center gap-2 lg:hidden"
        >
          <svg-icon
            src="./assets/icons/lottie/wave-lines-still.svg"
            [svgClass]="''"
          ></svg-icon>
          <!--          <div class="w-35 h-18 text-base-content">-->
          <!--            <ng-lottie [options]="theme === 'light' ? options_light : options_dark" (animationCreated)="animationCreated($event)" />-->
          <!--          </div>-->
          <svg-icon
            src="./assets/icons/logo_analyzr_black.svg"
            [svgClass]="'absolute h-6 w-18 text-base-content p0 -ml-28 -mt-3'"
          ></svg-icon>
        </a>
        <div class="lg:hidden">
          <app-drop-down></app-drop-down>
        </div>
      </div>
      <!--   Search Field   -->
    </div>

    <div class="flex xl:gap-1">
      <!-- Button Home / Dashboard -->
      <div class="hidden flex-none items-center lg:inline-block ml-4">
        @if (user$ | async) {
        <a
          routerLink="/dashboard"
          [routerLinkActive]="['active', 'disabled']"
          class="btn btn-sm btn-ghost drawer-button font-normal"
        >
          <svg-icon
            src="./assets/icons/heroicons/optimized/24/outline/home.svg"
            [svgClass]="'w-4 h-4 text-blue-500'"
          ></svg-icon>
          Dashboard
        </a>
        } @else {
        <a
          routerLink="/"
          [routerLinkActive]="['active', 'disabled']"
          [routerLinkActiveOptions]="{ exact: true }"
          class="btn btn-sm btn-ghost drawer-button font-normal"
        >
          <svg-icon
            src="./assets/icons/heroicons/optimized/24/outline/home.svg"
            [svgClass]="'w-4 h-4 text-base-content'"
          ></svg-icon>
          Home
        </a>
        }
      </div>

      <!-- Button Pricing -->
      <div class="hidden flex-none items-center lg:inline-block ml-4">
        <a
          routerLink="/pricing"
          [routerLinkActive]="['active', 'disabled']"
          class="btn btn-sm btn-ghost drawer-button font-normal"
        >
          <svg-icon
            src="./assets/icons/heroicons/optimized/24/outline/tag.svg"
            [svgClass]="'w-4 h-4 text-base-content'"
          ></svg-icon>
          Pricing
        </a>
      </div>

      <!-- Button Docs -->
      <div class="hidden flex-none items-center lg:inline-block ml-4">
        <a
          routerLink="/docs"
          [routerLinkActive]="['active', 'disabled']"
          class="btn btn-sm btn-ghost drawer-button font-normal"
        >
          <svg-icon
            src="./assets/icons/heroicons/optimized/24/outline/document-text.svg"
            [svgClass]="'w-4 h-4 text-base-content'"
          ></svg-icon>
          Docs
        </a>
      </div>

      <!-- Theme Switcher -->
      <div
        tabindex="0"
        role="button"
        class="btn group btn-sm gap-1.5 px-1.5 btn-ghost ml-4"
        aria-label="Change Theme"
        (click)="changeTheme($event)"
        [attr.data-set-theme]="theme === 'light' ? 'dark' : 'light'"
        [attr.title]="theme === 'light' ? 'Switch to Moon side!' : 'Switch to Sun side!'"
      >
        <svg-icon
          [src]="theme === 'light' ? './assets/icons/heroicons/optimized/24/outline/moon.svg' : './assets/icons/heroicons/optimized/24/outline/sun.svg'"
          [svgClass]="'w-4 h-4 text-base-content'"
        ></svg-icon>
      </div>

      <!-- Language Switcher -->
      <!--      <app-drop-down-language></app-drop-down-language>-->

      <!-- Login / Logout Button -->
      @if (user$ | async) {
      <button
        type="button"
        class="btn btn-sm btn-ghost gap-1 px-1.5 ml-4"
        aria-label="Logout"
        title="Logout"
        (click)="onLogout()"
      >
        <svg-icon
          src="./assets/icons/heroicons/optimized/24/outline/arrow-right-start-on-rectangle.svg"
          [svgClass]="'w-4 h-4 text-red-500'"
        ></svg-icon>
        <span class="hidden sm:inline">Logout</span>
      </button>
      } @else {
      <button
        type="button"
        class="btn btn-sm btn-ghost gap-1 px-1.5 ml-4"
        aria-label="Login"
        title="Login"
        routerLink="/login"
      >
        <svg-icon
          src="./assets/icons/heroicons/optimized/24/outline/arrow-left-end-on-rectangle.svg"
          [svgClass]="'w-4 h-4 text-green-500'"
        ></svg-icon>
        <span class="hidden sm:inline">Login</span>
      </button>
      }
    </div>
  </nav>
</div>

<!--</div>-->
